<template>
  <!-- Modal -->
  <div class="modal fade" id="NewBudgetModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('budget.editing') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{ translations('budget.sales_budget') }}</th>
                <th>{{ translations('budget.sales_performance') }}</th>
                <th>{{ translations('budget.sales_achievement_rate') }}</th>
                <th>{{ translations('budget.sales_compared_previous_period') }}</th>
                <th>{{ translations('budget.gross_profit_budget') }}</th>
                <th>{{ translations('budget.gross_profit_performance') }}</th>
                <th>{{ translations('budget.gross_profit_achievement_rate') }}</th>
                <th>{{ translations('budget.gross_profit_comparison_previous_period') }}</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <tr>
                <td><input type="text" min-value="0" class="form-control form-control-sm" placeholder="0" v-model="tempBudget.sales_budget"></td>
                <td><input type="text" min-value="0" class="form-control form-control-sm" placeholder="0" v-model="tempBudget.sales_result"></td>
                <td></td>
                <td></td>
                <td><input type="text" min-value="0" class="form-control form-control-sm" placeholder="0" v-model="tempBudget.gross_profit_budget"></td>
                <td><input type="text" min-value="0" class="form-control form-control-sm" placeholder="0" v-model="tempBudget.gross_profit_result"></td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="table-percent-label">0%</span>
                    <div class="progress w-100"><div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>
          <button type="button" class="btn btn-primary" @click="updateBudget()">{{ translations('common.update') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NewBudgetModal',
  props: {
    vat: {}, // VAT
    currentBudget: {}
  },
  watch: {
    currentBudget: {
      handler (v) {
        this.tempBudget = v
      },
      deep: true
    }
  },
  data () {
    return {
      tempBudget: {},
      isUpdated: false
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    filterTax (target, taxIncluded = null, vatRate = null) { // VAT INPUT @Modal
      target = target || 0
      taxIncluded = taxIncluded === null ? this.$props.vat.taxIncluded : taxIncluded
      vatRate = vatRate === null ? Number(this.$props.vat.vatRate) : Number(vatRate)
      if (!taxIncluded) {
        return target
      } else {
        let noTax = Math.round(target / ((100 + vatRate) / 100))
        return noTax
      }
    },
    updateBudget () {
      this.tempBudget.sales_budget = this.filterTax(this.tempBudget.sales_budget) // VAT INPUT @Modal
      this.tempBudget.sales_result = this.filterTax(this.tempBudget.sales_result)
      this.tempBudget.gross_profit_budget = this.filterTax(this.tempBudget.gross_profit_budget)
      this.tempBudget.gross_profit_result = this.filterTax(this.tempBudget.gross_profit_result)
      this.$parent.updateBudgetDetails(this.tempBudget)
      this.$refs['closeModal'].click()
    }
  }
}
</script>
